import { Component } from '@angular/core';
import { DisplayComponentInterface } from '@change-requests/interfaces/display-component.interface';

@Component({
    selector: 'end-date-display-component',
    template: `
        <div>
            <span *ngIf="value">
                {{ value ?? '-' | date: 'shortDate' }}
            </span>
            <span *ngIf="!value"> - </span>
        </div>
    `,
})
export class EndDateDisplayComponent implements DisplayComponentInterface {
    value = '';
}
